/* istanbul ignore file */
/* tslint:disable */
 
import type { AccidentParty } from '../models/AccidentParty';
import type { AccidentPartyWrite } from '../models/AccidentPartyWrite';
import type { PaginatedAccidentPartyList } from '../models/PaginatedAccidentPartyList';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ClaimsPartiesService {

  /**
   * List accident parties for a notification
   * /claims/notifications/{notification_pk}/parties/
 *
 * List, upsert (PUT), and delete culprit or claimant party.
   * @param notificationPk Accident notification ID
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @returns PaginatedAccidentPartyList 
   * @throws ApiError
   */
  public static claimsNotificationsPartiesList(
notificationPk: number,
page?: number,
pageSize?: number,
): CancelablePromise<PaginatedAccidentPartyList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/claims/notifications/{notification_pk}/parties/',
      path: {
        'notification_pk': notificationPk,
      },
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * Upsert accident party by role
   * Creates or replaces the culprit/claimant party for a notification. Always returns 200.
   * @param notificationPk Accident notification ID
   * @param role Party role
   * @param requestBody 
   * @returns AccidentParty 
   * @throws ApiError
   */
  public static claimsNotificationsPartiesUpdate(
notificationPk: number,
role: 'claimant' | 'culprit',
requestBody?: AccidentPartyWrite,
): CancelablePromise<AccidentParty> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/claims/notifications/{notification_pk}/parties/{role}/',
      path: {
        'notification_pk': notificationPk,
        'role': role,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Remove accident party by role
   * DELETE /claims/notifications/:id/parties/culprit/delete/ or /claimant/delete/
   * @param notificationPk Accident notification ID
   * @param role Party role
   * @returns void 
   * @throws ApiError
   */
  public static claimsNotificationsPartiesDeleteDestroy(
notificationPk: number,
role: 'claimant' | 'culprit',
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/claims/notifications/{notification_pk}/parties/{role}/delete/',
      path: {
        'notification_pk': notificationPk,
        'role': role,
      },
      errors: {
        404: `Party not found`,
      },
    });
  }

}
